<template>
  <div>
    <!-- items:{{ items }} -->
    <!-- <v-text-field v-model="model" label="Regular" clearable></v-text-field> -->
    <!-- required: {{ required }} -->
    <!-- vModel: {{ vModel }} schema:{{ schema }} k:{{ k }} -->

    <v-radio-group
      ref="rg"
      v-model="model"
      v-if="!isTab"
      :label="title"
      :row="row"
      :readonly="readonly"
    >
      <v-radio
        class="mb-2"
        v-for="i in items"
        :key="i[value] || i"
        :label="i[text] || capitalize(i)"
        :value="i[value] || i"
      ></v-radio>
    </v-radio-group>

    <v-tabs v-else ref="rg" v-model="model" :label="title">
      <v-tab
        class="mb-2"
        v-for="(i, ind) in items"
        :key="ind"
        :label="i[text] || capitalize(i)"
        :value="i[value] || i"
      >
        {{ i[text] || capitalize(i) }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import axios from "axios";
export default {
  name: "VRadioList",
  components: {},
  props: {
    vModel: [Object, Array, String, Number],
    label: String,
    objName: String,
    itemText: String,
    itemValue: String,
    default: Object,
    schema: Object,
    k: String,
    default_value: String,
    onChange: Function,
    returnObject: Boolean,
    readonly: Boolean,
  },
  data() {
    return {
      defaultItem: true,
      items: [],
      model: null,
      text: "",
      value: "",
      row: false,
      title: "",
      isTab: false,
      rules: null,
      required: false,
    };
  },
  mounted() {
    var that = this;
    // console.log(this);
    var objName = this.objName;
    this.text = this.itemText || "text";
    this.value = this.itemValue || "value";

    // if (this.onChange) {
    //   this.doChange = this.onChange;
    // }
    var vBind = null;
    if (this.schema) {
      try {
        vBind = this.schema[this.k]["v-bind"];
        this.row = vBind.row;
        objName = vBind.objName;
        this.items = vBind.items;
        this.text = vBind.itemText || "text";
        this.value = vBind.itemValue || "value";
        if (!vBind.hideTitle) {
          this.title = this.label;
        }
        this.isTab = vBind.isTab;
      } catch (error) {
        //
      }
    }
    var capitalize = vBind ? vBind.capitalizeText : this.capitalizeText;
    var localItems = false;
    try {
      this.defaultValue =
        this.schema[this.k].default_value || this.default_value;
    } catch (error) {
      //
    }

    if (!objName) {
      localItems = true;
      this.initItems();
    }

    if (!localItems) {
      var fields = "";
      if (this.itemText != this.itemValue) {
        fields = (this.itemText + "," + this.itemValue).split(",");
      } else {
        fields = this.itemValue;
      }
      var data = {
        object_name: vBind.objName,
        fields: fields,
        qry: vBind.qry,
        pipeline: vBind.pipeline,
        portal_id: vBind.portal_id,
        model: this.vModel,
      };
      var url = this.serverURL + "/get_records";
      axios
        .post(url, data, {
          withCredentials: true,
        })
        // var url =
        //   this.serverURL +
        //   "/get_records_qry_string?object_name=" +
        //   objName +
        //   "&fields=" +
        //   fields;
        // fetch(url)
        //   .then((res) => res.json())
        .then((response) => {
          // console.log(res);
          that.items = response.data[0];
          this.$root.$emit("radioListPopulated", this);
          if (that.itemText) {
            that.items.sort((a, b) => {
              return fun.compare(a, b, that.itemText);
            });
          }

          that.initItems(capitalize, this.itemText);
          if (vBind.defaultIndex == 0) {
            that.model = that.items[0][that.itemValue];
          }
          console.log(that.items);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }
  },
  beforeDestroy() {},
  methods: {
    capitalize(t) {
      return fun.capitalize(t);
    },
    resetModel() {
      this.model = null;
    },
    initItems() {
      var that = this;
      if (that.vModel) {
        that.model = Object.keys(that.vModel).length
          ? that.vModel
          : that.defaultValue;
      }

      // var d = that.model || that.default || that.defaultValue;
      // var k = "";
      //  && typeof that.items[0] != "object"
      // if (capitalize) {
      //   if (that.items.length) {
      //     that.items = fun.capitalizeItems(that.items, itemText);
      //   }
      // }
      // var defaultIndex = -1;
      // if (that.default && !that.model) {
      //   var defaultIndex = -1;
      //   k = Object.keys(d)[0];
      // } else {
      //   k = that.value;
      // }
      // that.items.forEach(function(item, idx) {
      //   if (d) {
      //     if (item[k] == d[k] || item.value == d) {
      //       defaultIndex = idx;
      //     }
      //   }
      // });
      // that.model = that.items[defaultIndex];
    },
  },
  watch: {
    model() {
      // console.log(val);
      var model = fun.clone(this.model);
      if (this.returnObject && this.model) {
        model = this.items.find((m) => {
          return m[this.itemValue] == this.model;
        });
      }
      // if (model != undefined) {
      this.$emit("input", model);
      // }
    },
  },
};
</script>

<style lang="css" scoped></style>
